import type { Battery, ServiceIntervalConfig, ServiceLifeStatus } from '../../types';
import { getServiceLifeRemaining } from '../getServiceLifeRemaining';

// Battery remaining service-life % = 100 - cycleCount / cycleInterval.
// cycleInterval is the configured battery part interval (unit: cycles).
export const getBatteryServiceLife = ({
    battery,
    cycleInterval
}: {
    battery: Battery;
    cycleInterval?: ServiceIntervalConfig;
}): ServiceLifeStatus =>
    getServiceLifeRemaining({ interval: cycleInterval, usage: battery.cycleCount });
